import { Link, useNavigate } from 'react-router'
import { ArrowLeft, Compass, LayoutDashboard } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="grid min-h-full place-items-center bg-[var(--color-page)] p-6">
      <div className="hrms-card w-full max-w-md px-8 py-10 text-center">
        <span className="mx-auto grid size-16 place-items-center rounded-2xl bg-[var(--color-primary-soft)] ring-8 ring-[var(--color-primary-soft)]/40">
          <Compass className="size-8 text-[var(--color-primary)]" aria-hidden="true" />
        </span>
        <p className="mt-6 text-xs font-semibold uppercase tracking-widest text-[var(--color-primary)]">
          Error 404
        </p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-[var(--color-heading)]">
          Page not found
        </h1>
        <p className="mt-2 text-sm text-[var(--color-muted)]">
          The page you are looking for does not exist or has moved. Check the address, or pick
          up from somewhere familiar.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-2">
          <Button variant="outline" onClick={() => void navigate(-1)}>
            <ArrowLeft className="rtl-flip" aria-hidden="true" /> Go back
          </Button>
          <Button asChild>
            <Link to="/"><LayoutDashboard aria-hidden="true" /> Back to dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
